<template>
  <content-display :facets="['page']" class="p-cms-page">
    <template v-slot:title>
      <distributor-header>
        <template slot="title">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="page.title" />
        </template>
      </distributor-header>
    </template>
    <template v-slot:default>
      <blog-header v-if="page.description" :description="page.description" />
      <cms-item-list :item-list="page.itemList" />
    </template>
  </content-display>
</template>

<script>
  import { transformKeysDeep } from '@/assets/js/util/misc/transform'
  import ContentDisplay from '@/components/content-display/content-display.vue'
  import CmsItemList from '@/components/cms/cms-item-list/cms-item-list'
  import DistributorHeader from '@/components/distributor-header/distributor-header'
  import { createHeadSeoData } from 'assets/js/util/nuxt/seo'
  import BlogHeader from '@/components/blog-header/blog-header'

  export default {
    components: { BlogHeader, DistributorHeader, CmsItemList, ContentDisplay },
    async asyncData({ $content, error, params }) {
      let page

      try {
        page = await $content('pages', params.id).fetch()
      } catch (e) {
        error({ statusCode: 404, message: 'CMS page not found!' })
      }

      return {
        page: transformKeysDeep(page),
      }
    },
    head() {
      return createHeadSeoData(this.$nuxtI18nHead(), {
        title: this.page.title,
        description: this.page.description || '',
      })
    },
  }
</script>
